import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { includes } from 'lodash';
import hash from 'object-hash';
import Alert from 'components/Alert';
import { getItem, setItem } from 'utils/LocalStorage';

class AlertContainer extends Component {
  constructor() {
    super();

    this.state = {
      isDismissed: false,
      isLoaded: false,
    };

    this.onClose = this.onClose.bind(this);
  }

  componentDidMount() {
    // This is required to keep the dismissed alert from appearing when rendered on the server.
    this.setState({ isLoaded: true }); // eslint-disable-line react/no-did-mount-set-state
  }

  onClose(id) {
    this.setState((prevState) => ({ isDismissed: !prevState.isDismissed }));

    const { isCached = true } = this.props;

    if (isCached) {
      const localStorageItemKey = 'dismissedAlerts';
      const dismissedAlerts = getItem(localStorageItemKey) || [];

      if (!includes(dismissedAlerts, id)) {
        dismissedAlerts.push(id);
      }

      setItem(localStorageItemKey, dismissedAlerts);
    }
  }

  render() {
    const { items = [], cssClass, type } = this.props;

    return (
      items.length > 0 &&
      <>
        {items.map((item) => {
          const { id, dismissible } = item;
          const { isDismissed, isLoaded } = this.state;
          const localStorageItemKey = 'dismissedAlerts';
          const dismissedAlerts = getItem(localStorageItemKey) || [];

          if (dismissible && isLoaded && (isDismissed || includes(dismissedAlerts, id))) {
            return null;
          }

          return (<Alert {...item} type={type} cssClass={cssClass} onClose={this.onClose} key={hash(item)} />);
        })}
      </>
    );
  }
}

AlertContainer.propTypes = {
  items: PropTypes.array.isRequired,
  isCached: PropTypes.bool,
  cssClass: PropTypes.string,
  type: PropTypes.string.isRequired,
};

export default AlertContainer;
